import formioSubmissionPrompt from "webforms/formio/formio-submission-prompt";

export default () => ({
  scope: false,
  link(scope, element, attr) {
    const $targets = attr.formioSubmissionPromptSelector
      ? element.find(attr.formioSubmissionPromptSelector)
      : element;
    $targets.on("click", (e) => formioSubmissionPrompt(attr));
  },
});
